export default __webpack_public_path__ + "static/media/our-team-03.d836d008.jpg";